var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TestCaseForm',{attrs:{"testCase":_vm.newTestCase,"title":"Create new test case","saveLabel":"Create"},on:{"save":_vm.createTestCase}})}
var staticRenderFns = []

export { render, staticRenderFns }